export default __webpack_public_path__ + "static/media/sql.c60c35d6.png";